import { atom } from 'recoil';

export const title = atom({
    key: 'title',
    default: 'Create Video',
    effects: [({ onSet }) => onSet(newVal => (document.title = newVal))],
});
